import QuoteOfTheDay from "./QuoteOfTheDay";
  
  export default QuoteOfTheDay;
  